/*
 * Copyright (C) 2018 envisia GmbH
 * All Rights Reserved.
 */
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Workflow} from '../models/workflow.models';

@Component({
    selector: 'workflow-document-list',
    templateUrl: './workflow-document-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowDocumentListComponent {
  @Input() workflow: Workflow;
  @Input() search: any;
}
